import React from 'react';
import styles from 'assets/css/StatusMessage.module.css';
import { IconCheckmarkCircle, IconCautionTriangle, IconSlashCircle } from '@ace/react-icons';
import { STATUS_STATE, statusMessageHelpers } from 'utils/statusUtils';

function StatusMessage({statusState, children}) {
    return (
        <span className={`${styles.status} ${statusMessageHelpers.getStatusStateTextClass(statusState)} ${statusMessageHelpers.getStatusStateSVGClass(statusState)}`}>
            {children}
        </span>
    )
};

export const StatusCheckmarkInfo = ({children}) => (
    <StatusMessage statusState={STATUS_STATE.INFO}>
        <IconCheckmarkCircle />
        {children}
    </StatusMessage>
);

export const StatusSlashWarn = ({children}) => (
    <StatusMessage statusState={STATUS_STATE.WARN}>
        <IconSlashCircle />
        {children}
    </StatusMessage>
);

export const StatusTriangleWarn = ({children}) => (
    <StatusMessage statusState={STATUS_STATE.WARN}>
        <IconCautionTriangle />
        {children}
    </StatusMessage>
);

export const StatusTriangleAlert = ({children}) => (
    <StatusMessage statusState={STATUS_STATE.ALERT}>
        <IconCautionTriangle />
        {children}
    </StatusMessage>
);

export default StatusMessage;